import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

interface Props {
  className?: string;
  width: number;
  height: number;
}

const DoughnutChartSkeleton = ({ className, width, height }: Props) => {
  return (
    <Box
      className={className}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Skeleton
        variant="circular"
        width={width}
        height={height}
        animation="pulse"
      />
    </Box>
  );
};

export default DoughnutChartSkeleton;
